export default __webpack_public_path__ + "static/media/Spiderman2_17.e41c6759.png";